//
// Valstream video player.
function Valstream(options){

    // Validate options.
    if(!options.hasOwnProperty('videoJsLibrary')
        || !options.videoJsLibrary
        || typeof options.videoJsLibrary !== 'function'
    ){

        throw new Error('Unable to configure Valstream, one or more required parameters are missing or invalid.');
    }

    this.__biddingManager                   = options.biddingManager || null;
    this.__googleAnalytics                  = options.googleAnalytics || null;
    this.__videoJsLibrary                   = options.videoJsLibrary;
    this.__googleLibrary                    = options.googleLibrary || null;
    this.__logger                           = new window.ValstreamLogger();
    this.__eventHelper                      = new window.AdsNinjaVideoPlayerEventHelper();
    this.__videoPlayers                     = {};
    this.__registeredBiddingManagerHandlers = false;

    // TODO: Would maybe need if we move back to TS/Modules approach.
    // window.videojs.registerPlugin('ads', window.videojsContribAds);
    // window.videojs.registerPlugin('videojsPlaylist', window.videojsPlaylist);
}

//
// Builds a video player.
Valstream.prototype.configureVideoPlayer = function(options){

    if(this.__videoPlayers.hasOwnProperty(options.elementId)){

        throw new Error(`Valstream video player already configured for element with ID: ${options.elementId}.`);
    }

    try{

        var videoPlayerOptions = new window.ValstreamVideoPlayerOptions();
        videoPlayerOptions.set_elementId(options.elementId);
        videoPlayerOptions.set_playlistVideoUrls(options.playlistVideoUrls || null); // For compatibility keep this option.
        videoPlayerOptions.set_playlist(options.playlist || null);
        videoPlayerOptions.set_maxAdErrorRetries(options.maxAdErrorRetries || null);
        videoPlayerOptions.set_maxPrerollAdCount(options.maxPrerollAdCount || null);
        videoPlayerOptions.set_autoNavTimeInMillisecondsNextVideoPrompt(options.autoNavTimeInMillisecondsNextVideoPrompt || null);
        videoPlayerOptions.set_autoNavTimeInMillisecondsNextVideoTransition(options.autoNavTimeInMillisecondsNextVideoTransition || null);
        videoPlayerOptions.set_prerollTimeoutInMilliseconds(options.prerollTimeoutInMilliseconds || null);
        videoPlayerOptions.set_modeLayout(options.modeLayout || null);
        videoPlayerOptions.set_allowAutoplay((typeof options.allowAutoplay === 'boolean') ? options.allowAutoplay : null);
        videoPlayerOptions.set_autoplay((typeof options.autoplay === 'boolean') ? options.autoplay : null);
        videoPlayerOptions.set_allowAutoPlaylistNavigation((typeof options.allowAutoPlaylistNavigation === 'boolean') ? options.allowAutoPlaylistNavigation : null);
        videoPlayerOptions.set_allowAutoplayWhenInView((typeof options.allowAutoplayWhenInView === 'boolean') ? options.allowAutoplayWhenInView : null);
        videoPlayerOptions.set_showTitle((typeof options.showTitle === 'boolean') ? options.showTitle : null);
        videoPlayerOptions.set_showOverlays((typeof options.showOverlays === 'boolean') ? options.showOverlays : null);
        videoPlayerOptions.set_allowAds((typeof options.allowAds === 'boolean') ? options.allowAds : null);
        videoPlayerOptions.set_changingVideoDetails((typeof options.changingVideoDetails === 'boolean') ? options.changingVideoDetails : null);
        videoPlayerOptions.set_delayAfterAdSkippedInMilliseconds(options.delayAfterAdSkippedInMilliseconds || null);
        videoPlayerOptions.set_delayAfterAdClosedInMilliseconds(options.delayAfterAdClosedInMilliseconds || null);
        videoPlayerOptions.set_useLargeSoundToggleButton((typeof options.useLargeSoundToggleButton === 'boolean') ? options.useLargeSoundToggleButton : null);
        videoPlayerOptions.set_soundOn((typeof options.soundOn === 'boolean') ? options.soundOn : null);
        videoPlayerOptions.set_requestDelayNoAdFillInMilliseconds(options.requestDelayNoAdFillInMilliseconds || null);
        videoPlayerOptions.set_requestDelayAdErrorInMilliseconds(options.requestDelayAdErrorInMilliseconds || null);
        videoPlayerOptions.set_forceAdSkip(options.forceAdSkip || null);
        videoPlayerOptions.set_forceAdSkipTimeoutInSeconds(options.forceAdSkipTimeoutInSeconds || null);
        videoPlayerOptions.set_adSchedule(options.adSchedule || null);
        videoPlayerOptions.set_biddingManager(this.__biddingManager);
        videoPlayerOptions.set_logger(this.__logger);
        videoPlayerOptions.set_googleAnalytics(this.__googleAnalytics);
        videoPlayerOptions.set_videoJsLibrary(this.__videoJsLibrary);
        videoPlayerOptions.set_googleLibrary(this.__googleLibrary);
        videoPlayerOptions.set_videoType(options.videoType || null);
        videoPlayerOptions.set_aspectRatio(options.aspectRatio || null);
        videoPlayerOptions.set_showClickThroughButton((typeof options.showClickThroughButton === 'boolean') ? options.showClickThroughButton : null);
        videoPlayerOptions.set_renderAdWithReponseOverTag((typeof options.renderAdWithReponseOverTag === 'boolean') ? options.renderAdWithReponseOverTag : null);
        videoPlayerOptions.set_externalFloatControl((typeof options.externalFloatControl === 'boolean') ? options.externalFloatControl : null);

        this.__videoPlayers[options.elementId] = new window.ValstreamVideoPlayer(videoPlayerOptions);

        return this.__videoPlayers[options.elementId];
    }
    catch(error){

        this.__logger.error(error.message);
    }
}

//
// Sets up video players for zones specified by a bidding manager.
Valstream.prototype.configureBiddingManagerVideoPlayers = function(){

    // Get all video players from biddingManager.
    var videoPlayerConfigs = this.__biddingManager.getVideoPlayerConfigurations();

    // Create video players.
    for(var x in videoPlayerConfigs) {

        if(this.__videoPlayers.hasOwnProperty(videoPlayerConfigs[x].elementId)){

            continue;
        }

        if(!document.getElementById(videoPlayerConfigs[x].elementId)){

            this.__logger.warn(`Unable to setup video player. Cannot find ad element with ID: ${videoPlayerConfigs[x].elementId}.`);

            continue;
        }

        videoPlayerConfigs[x]['allowAds'] = true;

        this.configureVideoPlayer(videoPlayerConfigs[x]);
    }

    // Register configure new video player handler.
    if(!this.__registeredBiddingManagerHandlers && typeof this.__biddingManager.registerConfigureNewVideoPlayersHandler === 'function'){

        var self = this;

        this.__biddingManager.registerConfigureNewVideoPlayersHandler(function(){

            self.configureBiddingManagerVideoPlayers();
        });

        this.__registeredBiddingManagerHandlers = true;
    }
}

//
// Returns video player.
Valstream.prototype.getVideoPlayer = function(elementId){

    return this.__videoPlayers[elementId] || null;
}

//
// Returns video players.
Valstream.prototype.getVideoPlayers = function(){

    return this.__videoPlayers;
}

window.Valstream = Valstream;